$(document).on('click', '.js-modalClose_city-hint', event => {
  event.preventDefault()
  $('#city-hint').css( "display", "none" )
})
